import { ClientDataConnectionDashboard } from './client-data-connection-dashboard'

const Index = () => <ClientDataConnectionDashboard />

export default Index
